import client from "./sharedoClient";
import queryString from "@/util/queryStringGenerator";
import { direction } from "@/util/sort";

const defaultGetOptions = {
    filter: "",
    sort: {
        by: "title",
        direction: direction.ASCENDING
    },
    paging: {
        page: 1,
        pageSize: 10
    }
};

const get = options => {
    const opts = Object.assign({}, defaultGetOptions, options);

    const payload = {
        sortColumn: opts.sort.by,
        sortDirection: opts.sort.direction,
        page: opts.paging.page,
        pageSize: opts.paging.pageSize
    };

    if (opts.filter) {
        payload.filterField = "title";
        payload.filter = opts.filter;
    }

    return client.post("api/wordaddin/templates/_list", payload);
};

const getOne = systemName => client.get(`api/wordaddin/templates/${systemName}`);

const getMany = (...systemNames) => {
    const opts = { systemName: [...systemNames] };
    return client.get(`api/wordaddin/templates${queryString.generate(opts)}`);
}

export default {
    get,
    getOne,
    getMany
}